<template>
  <el-dialog
    title="DESADV szállítólevél létrehozása"
    :visible="true"
    width="900px"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <el-form label-position="top">
      <el-form-item label="Vevői megrendelés">
        <el-select
          v-model="selectedOrderId"
          filterable
          clearable
          style="width: 100%;"
          placeholder="Válasszon megrendelést..."
          :loading="orderLoading"
          @change="onOrderSelected"
        >
          <el-option
            v-for="o in orderOptions"
            :key="o.id"
            :label="orderLabel(o)"
            :value="o.id"
          />
        </el-select>
        <div
          v-if="!orderLoading && !orderOptions.length"
          class="empty-hint"
        >
          Nincs DESADV-olható megrendelés. Csak EDI-ből érkezett, a raktárnak
          már elküldött megrendelésre hozható létre szállítólevél.
        </div>
      </el-form-item>
    </el-form>

    <div v-if="source">
      <div
        v-if="hasEdiIssues"
        class="edi-issues"
      >
        <div class="edi-issues-title">
          A DESADV nem hozható létre, mert az EDI üzenet nem lenne kiküldhető:
        </div>
        <div
          v-if="ediIssues.missing_identifiers.length"
          class="edi-issues-block"
        >
          A fogadott EDI rendelésről hiányzik:
          {{ ediIssues.missing_identifiers.join(', ') }}. Ezt a beérkezett ORDERS
          üzenet tartalmazza, kézzel nem pótolható — jelezze az EDI partnernek.
        </div>
        <div
          v-if="ediIssues.missing_eans.length"
          class="edi-issues-block"
        >
          <div>Az alábbi termékeknek nincs EAN kódja:</div>
          <ul class="edi-issues-list">
            <li
              v-for="row in ediIssues.missing_eans"
              :key="row.product_pack_type_id"
            >
              {{ row.name }}<template v-if="row.pack_type_name"> ({{ row.pack_type_name }})</template>
              —
              <a
                :href="productEditHref(row)"
                target="_blank"
              >EAN pótlása a termék adatlapján</a>
            </li>
          </ul>
          <el-button
            size="mini"
            @click="onOrderSelected(selectedOrderId)"
          >
            Újraellenőrzés
          </el-button>
        </div>
      </div>

      <h4>A megrendelés tételei</h4>
      <coverage-table
        :source-items="source.items"
        :coverage="source.coverage"
      />
    </div>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="close">
        Mégse
      </el-button>
      <el-button
        type="success"
        :disabled="!selectedOrderId || hasEdiIssues"
        :loading="saving"
        @click="createDesadv"
      >
        DESADV létrehozása
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import CoverageTable from './CoverageTable';

export default {
  components: {
    CoverageTable,
  },
  data() {
    return {
      saving: false,
      selectedOrderId: null,
      orderOptions: [],
      orderLoading: false,
      source: null,
    };
  },
  computed: {
    ediIssues() {
      return (this.source && this.source.edi_issues) || { missing_identifiers: [], missing_eans: [] };
    },
    hasEdiIssues() {
      return this.ediIssues.missing_identifiers.length > 0 || this.ediIssues.missing_eans.length > 0;
    },
  },
  mounted() {
    this.fetchOrders();
  },
  methods: {
    productEditHref(row) {
      return this.$router.resolve('/data/products/update/' + row.product_id).href;
    },
    close() {
      this.$router.replace('/sales/desadvs');
    },
    orderLabel(o) {
      const customer = o.customer_name ? ' · ' + o.customer_name : '';
      const date = o.delivery_date ? ' · ' + o.delivery_date.substr(0, 10) : '';
      return `${o.receipt_number || '#' + o.id}${customer}${date}`;
    },
    async fetchOrders() {
      this.orderLoading = true;
      try {
        this.orderOptions = await this.$store.dispatch('desadv/fetchSelectableOrders') || [];
      } catch (e) {
      }
      this.orderLoading = false;
    },
    async onOrderSelected(id) {
      this.source = null;
      if (!id) return;
      try {
        this.source = await this.$store.dispatch('desadv/fetchSource', id);
      } catch (e) {
      }
    },
    async createDesadv() {
      this.saving = true;
      try {
        const response = await this.$store.dispatch('desadv/createFromOrder', { customer_order_id: this.selectedOrderId });
        this.$router.replace('/sales/desadvs/view/' + response.id);
      } catch (e) {
      }
      this.saving = false;
    },
  },
};
</script>

<style scoped>
.edi-issues {
  border: 1px solid #f56c6c;
  border-radius: 4px;
  background: #fef0f0;
  color: #f56c6c;
  padding: 12px 16px;
  margin-bottom: 16px;
  line-height: 1.5;
  font-size: 13px;
}
.edi-issues-title {
  font-weight: bold;
  margin-bottom: 6px;
}
.edi-issues-block + .edi-issues-block {
  margin-top: 8px;
}
.edi-issues-list {
  margin: 4px 0 8px;
  padding-left: 20px;
}
.edi-issues-list a {
  color: #409eff;
}
.empty-hint {
  line-height: 1.4;
  font-size: 12px;
  color: #909399;
}
</style>
